import React from 'react';
export var FlagContext = React.createContext({});
FlagContext.displayName = 'FlagContext';
//# sourceMappingURL=FlagContext.js.map